"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientDataStorageProvider = void 0;
const client_data_loader_1 = require("./client_data_loader");
class ClientDataStorageProvider extends client_data_loader_1.ClientDataLoader {
    constructor(options) {
        super();
        this.operationExecuted = options.operationExecuted;
    }
    saveOps(ops) {
        this.operationExecuted(ops);
    }
}
exports.ClientDataStorageProvider = ClientDataStorageProvider;
